import { Row } from '@kerfjs/ui/row';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import { failedOrderSummary, orderSummary, receiptSummary } from '../../shared/fulfilment.js';
import type { LineOrderT } from '../data/api.js';
import { LINE_ITEM_SECTION_VALUES_FLEX, LineItemSectionLabel } from './line-item-section-label.js';

/**
 * A line's purchase order (FR-5.18, HS2-HYDRJX): "Ordered · PO 1234 · Acme · expected 12 Oct", shown
 * to staff and to the requester, who mostly wants to know whether it is ordered and when it arrives.
 */
export function DemandLineItemOrder({
  order,
  failed,
}: {
  order: LineOrderT | undefined;
  /** The newest failed order of a line being re-sourced (FR-5.21, HS2-SFY5DY). */
  failed?: LineOrderT;
}): SafeHtml {
  if (order === undefined && failed !== undefined)
    return (
      <Row className="demand-line-item-order" vAlign="top" wrap rootAttributes={{ 'data-order-state': 'failed' }}>
        <LineItemSectionLabel label="Order" />
        <Row flex={LINE_ITEM_SECTION_VALUES_FLEX} wrap vAlign="middle" controlInsets="rl">
          <Text tone="danger">{failedOrderSummary(failed)}</Text>
        </Row>
      </Row>
    );
  if (order === undefined) return <></>;
  return (
    <Row className="demand-line-item-order" vAlign="top" wrap>
      <LineItemSectionLabel label="Order" />
      <Row flex={LINE_ITEM_SECTION_VALUES_FLEX} wrap vAlign="middle" controlInsets="rl">
        <Text>{[orderSummary(order), receiptSummary(order)].filter((part) => part !== '').join(' · ')}</Text>
      </Row>
    </Row>
  );
}
